import { useTranslation } from '@thoughtspot/i18n';
import { Alert, BannerAlertType, } from '@thoughtspot/radiant-react/widgets/alert';
import { FormBuilder } from '@thoughtspot/radiant-react/widgets/form-builder';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { useGetOrgByIdLazyQuery } from "../../../services/org/org-service";
import { getAddEditOrgElementsConfig, TranslationsKeys, } from '../orgs-interface';
import styles from './create-edit-modal.module.scss';
export const CreateEditModal = ({ isModalOpened, closeModal, isEditMode = false, orgId = '', setIsRefresh = _.noop, updateOrgRecord, createOrgRecord, showError = null, setShowError, setIsLoading, }) => {
    const { t } = useTranslation();
    const formBuilderRef = useRef(null);
    const [isEditReady, setIsEditReady] = useState(false);
    const { data: orgByIdData, error: orgByIdError, loading: orgByIdLoading, getOrgById, } = useGetOrgByIdLazyQuery(orgId);
    const getUpdatedFormField = (currentFormData = getAddEditOrgElementsConfig(t)) => {
        const newFormFields = [];
        const orgByIdRecord = orgByIdData?.Data;
        currentFormData.forEach((field) => {
            let value = field.value || '';
            const config = field.config;
            if (orgByIdRecord) {
                if (field.id === 'name') {
                    value = orgByIdRecord?.orgName || '';
                }
                else if (field.id === 'description') {
                    const desc = orgByIdRecord?.description || '';
                    if (desc === 'undefined') {
                        value = '';
                    }
                    else {
                        value = desc;
                    }
                }
            }
            newFormFields.push({
                ...field,
                ...config,
                value,
            });
        });
        return newFormFields;
    };
    const [formFields, setFormFields] = useState(getUpdatedFormField());
    const updateFormFields = (currentFormData = getAddEditOrgElementsConfig(t)) => {
        const newFormFields = getUpdatedFormField(currentFormData);
        setFormFields(newFormFields);
    };
    useEffect(() => {
        updateFormFields();
    }, []);
    useEffect(() => {
        if (orgId) {
            setIsLoading(true);
            getOrgById();
        }
    }, [orgId]);
    useEffect(() => {
        updateFormFields();
        if (!orgByIdLoading && orgByIdData?.Data) {
            setIsLoading(false);
            setIsEditReady(true);
        }
    }, [orgByIdData, orgByIdLoading]);
    const onSuccess = (newOrgData) => {
        if (isEditMode && orgId) {
            const updatedOrgData = { orgid: orgId, ...newOrgData };
            updateOrgRecord(updatedOrgData);
        }
        else {
            createOrgRecord(newOrgData);
        }
    };
    const submitForm = () => {
        const currentFormData = formBuilderRef.current.validateAndSubmitForm();
        const allValid = currentFormData.filter((field) => field.valid === false)
            .length < 1;
        if (allValid) {
            const newOrgData = {};
            currentFormData.forEach((field) => {
                newOrgData[field.id] = field.value || '';
            });
            onSuccess(newOrgData);
        }
    };
    const onDismissModal = () => {
        setShowError(null);
        closeModal();
    };
    const onConfirmModal = () => {
        submitForm();
    };
    const modalProps = {
        size: ModalSize.SMALL,
        title: isEditMode
            ? t(TranslationsKeys.EDIT_ORG_PAGE_TITLE)
            : t(TranslationsKeys.ADD_ORG_PAGE_TITLE),
        onDismiss: onDismissModal,
        isOpen: isModalOpened,
        confirmButton: {
            text: t(TranslationsKeys.SAVE),
            onConfirm: onConfirmModal,
        },
        dismissButton: {
            text: t(TranslationsKeys.CANCEL),
        },
        className: styles.modalProps,
        autoScrollContent: false,
    };
    return (React.createElement(React.Fragment, null, (!isEditMode || (isEditMode && isEditReady)) && (React.createElement(Modal, { ...modalProps },
        React.createElement(Vertical, { hAlignContent: "stretch", grow: true },
            React.createElement(Alert.Banner, { message: showError, isVisible: !!showError, type: BannerAlertType.ERROR, className: styles.alertBanner, onClose: () => setShowError(null) }),
            React.createElement("div", { "data-testid": "orgsModal_add", role: "presentation", onKeyDown: e => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        submitForm();
                    }
                } },
                React.createElement(FormBuilder, { ref: formBuilderRef, formFields: formFields })))))));
};
//# sourceMappingURL=create-edit-modal.container.js.map